<script>
import Vue from 'vue'
// resources
import ScaleResource from '../../resources/scale'
import UnionRulesetResource from '../../resources/unionRuleset'
import AgreementResource from '../../resources/agreement'
import UnionLocalResource from '../../resources/unionLocal'
import UnionJurisdictionResource from '../../resources/unionJurisdiction'
import ScheduleResource from '../../resources/schedule'
import JobTitleResource from '../../resources/jobTitle'
import AgreementUnionMxResource from '../../resources/agreementUnionMx'

// components&views
import AutoComplete from '../../components/Autocomplete.vue'
import ScaleGrid from '../../components/scale_grid/ScaleGrid'
import UnionRulesetGrid from '../../components/union_ruleset_grid/UnionRulesetGrid'
import AgreementUnionMxGrid from '../../components/agreement_union_mx_grid/AgreementUnionMxGrid.vue'

// mixins
import toastMixin from '../../mixins/toast'
import modalMixin from '../../mixins/modal'
import { scaleFormSet } from '../../resources/formsets/scale'

export default Vue.extend({
    data() {
        return {
            options: {
                union_local_id: [],
            },
            scaleData: undefined,
            unionRulesetData: undefined,
            scaleResourcesData: [],
            unionRulesetResourcesData: [],
            agreementUnionMxData: undefined,
            agreementUnionMxResourcesData: [],
            isActive: undefined,
            isSaving: false,
            scaleIteration: 0,
            unionRulesetIteration: 10000,
            agreementUnionMxIteration: 20000,
            jobTitleName: '',
        }
    },
    mixins: [toastMixin, modalMixin],
    components: {
        AutoComplete,
        ScaleGrid,
        UnionRulesetGrid,
        AgreementUnionMxGrid,
    },
    computed: {
        resources() {
            return {
                ScaleResource,
                UnionRulesetResource,
                AgreementResource,
                UnionLocalResource,
                UnionJurisdictionResource,
                ScheduleResource,
                JobTitleResource,
                AgreementUnionMxResource,
            }
        },
        formsets() {
            return {
                scaleFormSet,
            }
        },
    },
    methods: {
        async getData() {
            // we need to reset these two array to avoid to show previous data.
            this.scaleResourcesData = []
            this.unionRulesetResourcesData = []
            this.agreementUnionMxResourcesData = []
            let jobTitleData = []
            let options = {}

            if (this.jobTitleName) {
                // get all job title id first
                options.name__contains = this.jobTitleName
                jobTitleData = await this.resources.JobTitleResource.all(options)
            }

            options = {}
            for (const label in this.options) {
                const opt = this.options[label]
                if (opt && Array.isArray(opt) && opt.length > 0) {
                    options[label + '__in'] = opt.join(',')
                } else if (opt) {
                    options[label] = opt
                }
            }

            if (this.jobTitleName) {
                // loop for scale and unionRuleset by each job id
                for (let job of jobTitleData) {
                    options.job_title_id = job.attributes.id

                    const scaleData = await this.resources.ScaleResource.all(options)
                    for (const i in scaleData) {
                        const datum = scaleData[i]
                        await datum.resolveRelated()
                        this.scaleResourcesData.push(datum)
                    }

                    const unionRulesetData = await this.resources.UnionRulesetResource.all(options)
                    for (const i in unionRulesetData) {
                        const datum = unionRulesetData[i]
                        await datum.resolveRelated()
                        this.unionRulesetResourcesData.push(datum)
                    }
                }
            } else {
                // need to remove remain job id data after changed job title value from something to empty
                options.job_title_id = undefined

                const scaleData = await this.resources.ScaleResource.all(options)
                for (const i in scaleData) {
                    const datum = scaleData[i]
                    await datum.resolveRelated()
                    this.scaleResourcesData.push(datum)
                }

                const unionRulesetData = await this.resources.UnionRulesetResource.all(options)
                for (const i in unionRulesetData) {
                    const datum = unionRulesetData[i]
                    await datum.resolveRelated()
                    this.unionRulesetResourcesData.push(datum)
                }
            }

            // Get Agreement Union MX Data
            const agreementUnionMxData = await this.resources.AgreementUnionMxResource.all(options)
            for (const i in agreementUnionMxData) {
                const datum = agreementUnionMxData[i]
                await datum.resolveRelated()
                this.agreementUnionMxResourcesData.push(datum)
            }

            this.scaleData = this.scaleResourcesData
            this.unionRulesetData = this.unionRulesetResourcesData
            this.agreementUnionMxData = this.agreementUnionMxResourcesData
            this.scaleIteration++
            this.unionRulesetIteration++
            this.agreementUnionMxIteration++
        },
        updateAgreement(event) {
            if (event && event.id) {
                this.options.agreement_id = event.id
            } else {
                this.options.agreement_id = undefined
            }
        },
        updateUnionLocal(event) {
            if (event && event.id) {
                this.options.union_local_id = event.id
            } else {
                this.options.union_local_id = undefined
            }
        },
        updateUnionJurisdiction(event) {
            if (event && event.id) {
                this.options.union_jurisdiction_id = event.id
            } else {
                this.options.union_jurisdiction_id = undefined
            }
        },
        updateSchedule(event) {
            if (event && event.id) {
                this.options.schedule_id = event.id
            } else {
                this.options.schedule_id = undefined
            }
        },
        updateDateStart(event) {
            // console.log(event)
            if (event.target && event.target.value) {
                this.options.date_start = event.target.value
            } else {
                delete this.options.date_start
            }
        },
        updateDateEnd(event) {
            if (event.target && event.target.value) {
                this.options.date_end = event.target.value
            } else {
                delete this.options.date_end
            }
        },
        updateIsActive() {
            if (this.isActive) {
                // show only active
                this.options.status = 1
            } else {
                // show all
                this.options.status = 0
            }
        },
        selectScale(selectedResource) {
            if (selectedResource && selectedResource.id) this.selectedScaleResource = selectedResource
        },
        selectUnionRuleset(selectedResource) {
            if (selectedResource && selectedResource.id) this.selectedUnionRulesetResource = selectedResource
        },
        async locals() {
            return []
            let result
            if (this.options.agreement_id) {
                result = await this.resources.UnionLocalResource.all({ options: this.options })
            } else {
                result = await this.resources.UnionLocalResource.all()
            }
            // console.log(result)
            return result
        },
    },
    async mounted() {
        await this.resources.ScheduleResource.all()
        await this.resources.JobTitleResource.all()
    },
})
</script>

<template>
    <div class="pageStyling">
        <b-row>
            <b-col cols="4">
                <p>Agreement</p>
                <auto-complete name="agreements" placeholder="Agreement" :resource-class="this.resources.AgreementResource" :defaultShowResources="true" @select="updateAgreement($event)">
                    <template slot="item" slot-scope="option">
                        <p>{{ option.item.name }}</p>
                    </template>
                </auto-complete>
            </b-col>
            <b-col>
                <p>Local</p>
                <auto-complete name="unionLocal" placeholder="Local" :resource-class="this.resources.UnionLocalResource" @select="updateUnionLocal($event)">
                    <template slot="item" slot-scope="option">
                        <p>{{ option.item.name }}</p>
                    </template>
                </auto-complete>
            </b-col>
            <b-col cols="2">
                <p>Job Position</p>
                <input class="form-control" name="jobTitle_name" v-model="jobTitleName" />
            </b-col>
            <b-col cols="2">
                <p>Date Start</p>
                <input class="form-control" @change="updateDateStart" />
            </b-col>
            <b-col cols="2">
                <p>Date End</p>
                <input class="form-control" @change="updateDateEnd" />
            </b-col>
            <b-col cols="1">
                <p>Active Only</p>
                <input type="checkbox" v-model="isActive" @change="updateIsActive" />
            </b-col>
            <b-col>
                <b-button @click="getData">Search</b-button>
            </b-col>
        </b-row>
        <agreement-union-mx-grid :row-data="agreementUnionMxData" :key="agreementUnionMxIteration" class="ag-theme-balham agGrid" />
        <union-ruleset-grid :row-data="unionRulesetData" :key="unionRulesetIteration" class="ag-theme-balham agGrid" @select="selectUnionRuleset" />
        <scale-grid :row-data="scaleData" :key="scaleIteration" class="ag-theme-balham agGrid" @select="selectScale" />
    </div>
</template>

<style scoped>
.pageStyling {
    margin: 50px 0px 0px 25px;
}

.autocompleteContainer {
    width: 25%;
}

.agGrid {
    margin: 50px 0px 0px 0px;
}

.buttonContainer {
    display: flex;
    margin-top: 20px;
}

.buttonContainer > * {
    margin-right: 20px;
}
</style>
